/* Audio player context value. Split from provider to satisfy ESLint react-refresh. */

import { createContext } from "react";
import type { PodcastTrack, AudioPlayerState } from "@/types/audioPlayer";

export interface AudioPlayerContextValue {
  state: AudioPlayerState;
  play: (track: PodcastTrack) => void;
  pause: () => void;
  resume: () => void;
  togglePlayPause: () => void;
  seek: (seconds: number) => void;
  skipForward: (seconds?: number) => void;
  skipBack: (seconds?: number) => void;
  setSpeed: (speed: number) => void;
  setSleepTimer: (minutes: number | "end") => void;
  cancelSleepTimer: () => void;
  stop: () => void;
}

export const AudioPlayerContext = createContext<AudioPlayerContextValue | null>(null);
